import * as S from './style';

export const ActionBar = () => {
  return (
    <S.ActionBar>
      <h3>
        Converse com um especialista e descubra como prevenir falhas antes que aconteçam :)
      </h3>
      <S.ActionBtn
        className="action-btn"
        onClick={() => window.open("https://wa.me/5541999981633", "_blank")}
      >
        Agende uma demonstração
      </S.ActionBtn>
    </S.ActionBar>
  )
}
